import { createDestinationsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useDestinationsQuery = createDestinationsQuery(HTTP_CONFIG.API.Optimizely.url)
